<div
  class="container py-5 d-flex justify-content-center align-items-center vh-100"
>
  <div class="row w-100 justify-content-center">
    <div
      class="col-12 col-md-12 col-lg-9 d-flex flex-column align-items-center justify-content-center text-center"
    >
      <div class="mx-auto mb-4">
        <img
          src="https://res.cloudinary.com/pervolare-org/image/upload/v1760645306/TAS/rutt/icon-thankyou-page_b9lpwt.png"
          alt="icon succes"
          class="img-fluid"
        />
        <i class="bi bi-check-circle-fill success-check-icon"></i>
      </div>

      <h1 class="f-24 f-lg-32 fw-bold text-primary mb-4">
        ¡Solicitud realizada con éxito!
      </h1>

      @if (numeroCaso) {
        <p class="text-title f-18 mb-3 fw-bold">
          Tu número de caso es:
          <span class="text-primary">{{ numeroCaso }}</span>
        </p>
      }

      <p class="text-title f-16 mb-3">
        Recibirás respuesta por correo electrónico en
        @if (brandService.theme.name.toLowerCase().includes("pervolare")) {
          <span class="fw-bold">3 a 5 días hábiles.</span>
        } @else {
          <span class="fw-bold">1 a 3 días hábiles.</span>
        }
      </p>

      <p class="f-16 text-title mb-4 px-md-5">
        Nota: Algunos casos requieren validación de otras áreas, por lo que el
        proceso puede tardar
        @if (brandService.theme.name.toLowerCase().includes("pervolare")) {
          <span class="fw-bold">hasta 45 días hábiles.</span>
        } @else {
          <span class="fw-bold">hasta 30 días hábiles.</span>
        }
        Si necesitamos más información, te contactaremos por correo electrónico.
      </p>

      <div class="d-flex flex-column flex-sm-row justify-content-center gap-3">
        <button
          type="button"
          class="btn btn-action btn-width"
          (click)="verReembolsos()"
        >
          Ver tus reembolsos
        </button>
      </div>
    </div>
  </div>
</div>